import { z } from 'zod';
export const AuditEventType = {
    USER_LOGIN: 'USER_LOGIN',
    USER_LOGIN_FAILED: 'USER_LOGIN_FAILED',
    USER_LOGOUT: 'USER_LOGOUT',
    MFA_ENABLED: 'MFA_ENABLED',
    MFA_LOGIN_FAILED: 'MFA_LOGIN_FAILED',
    APP_MFA_VERIFIED: 'APP_MFA_VERIFIED',
    APP_MFA_FAILED: 'APP_MFA_FAILED',
    MFA_RESET: 'MFA_RESET',
    PLATFORM_CA_CREATED: 'PLATFORM_CA_CREATED',
    PLATFORM_CERTIFICATE_ISSUED: 'PLATFORM_CERTIFICATE_ISSUED',
    PASSWORD_RESET_REQUESTED: 'PASSWORD_RESET_REQUESTED',
    PASSWORD_RESET: 'PASSWORD_RESET',
    USER_CREATED: 'USER_CREATED',
    USER_UPDATED: 'USER_UPDATED',
    USER_INVITED: 'USER_INVITED',
    USER_ACTIVATED: 'USER_ACTIVATED',
    USERS_IMPORTED: 'USERS_IMPORTED',
    ENTITY_CREATED: 'ENTITY_CREATED',
    ENTITY_UPDATED: 'ENTITY_UPDATED',
    ENTITY_APP_ENABLED: 'ENTITY_APP_ENABLED',
    ENTITY_APP_DISABLED: 'ENTITY_APP_DISABLED',
    ENTITY_APP_PROVISIONED: 'ENTITY_APP_PROVISIONED',
    ENTITY_APP_PROVISIONING_FAILED: 'ENTITY_APP_PROVISIONING_FAILED',
    ENTITY_MODULES_CHANGED: 'ENTITY_MODULES_CHANGED',
    MEMBERSHIP_CREATED: 'MEMBERSHIP_CREATED',
    MEMBERSHIP_UPDATED: 'MEMBERSHIP_UPDATED',
    MEMBERSHIP_REMOVED: 'MEMBERSHIP_REMOVED',
    IDP_CHANGED: 'IDP_CHANGED',
    ENTITY_MAIL_CHANGED: 'ENTITY_MAIL_CHANGED',
    ENTITY_SETTINGS_CHANGED: 'ENTITY_SETTINGS_CHANGED',
    ENTITY_DOMAIN_ADDED: 'ENTITY_DOMAIN_ADDED',
    ENTITY_DOMAIN_VERIFIED: 'ENTITY_DOMAIN_VERIFIED',
    ENTITY_DOMAIN_REMOVED: 'ENTITY_DOMAIN_REMOVED',
    PLATFORM_MAIL_CHANGED: 'PLATFORM_MAIL_CHANGED',
    BACKUP_SETTINGS_CHANGED: 'BACKUP_SETTINGS_CHANGED',
    BACKUP_STARTED: 'BACKUP_STARTED',
    ENTITY_LOGO_CHANGED: 'ENTITY_LOGO_CHANGED',
    ENTITY_SOURCE_CREATED: 'ENTITY_SOURCE_CREATED',
    ENTITY_SOURCE_UPDATED: 'ENTITY_SOURCE_UPDATED',
    ENTITY_SOURCE_DELETED: 'ENTITY_SOURCE_DELETED',
    ENTITY_SOURCE_ASSIGNED: 'ENTITY_SOURCE_ASSIGNED',
    ENTITY_KEY_CONFIGURED: 'ENTITY_KEY_CONFIGURED',
    ENTITY_KEY_ROTATED: 'ENTITY_KEY_ROTATED',
    ENTITY_KEY_TESTED: 'ENTITY_KEY_TESTED',
    ENTITY_KEY_UNAVAILABLE: 'ENTITY_KEY_UNAVAILABLE',
    MEMBER_APP_ROLES_CHANGED: 'MEMBER_APP_ROLES_CHANGED',
    APP_ROLES_PUBLISHED: 'APP_ROLES_PUBLISHED',
    APP_MAIL_FEATURES_PUBLISHED: 'APP_MAIL_FEATURES_PUBLISHED',
    APP_MODULES_PUBLISHED: 'APP_MODULES_PUBLISHED',
    ENTITY_MAIL_ROUTE_CHANGED: 'ENTITY_MAIL_ROUTE_CHANGED',
    DATA_LOCATION_CREATED: 'DATA_LOCATION_CREATED',
    APP_REGISTERED: 'APP_REGISTERED',
    APP_UPDATED: 'APP_UPDATED',
    APP_SECRET_ROTATED: 'APP_SECRET_ROTATED',
    OIDC_LOGIN: 'OIDC_LOGIN',
    NOTIFICATIONS_PUSHED: 'NOTIFICATIONS_PUSHED',
    ENTITY_UNIT_CREATED: 'ENTITY_UNIT_CREATED',
    ENTITY_UNIT_UPDATED: 'ENTITY_UNIT_UPDATED',
    ENTITY_UNIT_MOVED: 'ENTITY_UNIT_MOVED',
    ENTITY_UNIT_ARCHIVED: 'ENTITY_UNIT_ARCHIVED',
    ENTITY_UNIT_RESTORED: 'ENTITY_UNIT_RESTORED',
    ENTITY_UNIT_DELETED: 'ENTITY_UNIT_DELETED',
    ENTITY_UNIT_MEMBERS_CHANGED: 'ENTITY_UNIT_MEMBERS_CHANGED',
    ENTITY_UNITS_IMPORTED: 'ENTITY_UNITS_IMPORTED',
    ENTITY_UNIT_CHANGE_BLOCKED: 'ENTITY_UNIT_CHANGE_BLOCKED',
};
/** Nombre de cada evento en la interfaz (la consulta sigue usando el código). */
export const AUDIT_EVENT_LABEL = {
    USER_LOGIN: 'Ingreso a la suite',
    USER_LOGIN_FAILED: 'Ingreso fallido',
    USER_LOGOUT: 'Salida de la suite',
    MFA_ENABLED: 'Verificación en dos pasos activada',
    MFA_LOGIN_FAILED: 'Código de dos pasos incorrecto',
    APP_MFA_VERIFIED: 'Código de la app autenticadora aceptado en una app (firma)',
    APP_MFA_FAILED: 'Código de la app autenticadora rechazado en una app (firma)',
    MFA_RESET: 'Verificación en dos pasos restablecida',
    PLATFORM_CA_CREATED: 'CA interna de la suite creada',
    PLATFORM_CERTIFICATE_ISSUED: 'Certificado de la plataforma emitido',
    PASSWORD_RESET_REQUESTED: 'Recuperación de contraseña solicitada',
    PASSWORD_RESET: 'Contraseña restablecida',
    USER_CREATED: 'Cuenta creada',
    USER_UPDATED: 'Cuenta modificada',
    USER_INVITED: 'Invitación enviada',
    USER_ACTIVATED: 'Cuenta activada',
    USERS_IMPORTED: 'Personas importadas',
    ENTITY_CREATED: 'Entidad creada',
    ENTITY_UPDATED: 'Entidad modificada',
    ENTITY_APP_ENABLED: 'App habilitada',
    ENTITY_APP_DISABLED: 'App deshabilitada',
    ENTITY_APP_PROVISIONED: 'App aprovisionada',
    ENTITY_APP_PROVISIONING_FAILED: 'Aprovisionamiento fallido',
    ENTITY_MODULES_CHANGED: 'Módulos cambiados',
    MEMBERSHIP_CREATED: 'Persona agregada a la entidad',
    MEMBERSHIP_UPDATED: 'Persona de la entidad modificada',
    MEMBERSHIP_REMOVED: 'Persona quitada de la entidad',
    IDP_CHANGED: 'Ingreso institucional cambiado',
    ENTITY_MAIL_CHANGED: 'Correo de la entidad cambiado',
    ENTITY_SETTINGS_CHANGED: 'Ajustes de la entidad cambiados',
    ENTITY_DOMAIN_ADDED: 'Dominio propio agregado',
    ENTITY_DOMAIN_VERIFIED: 'Dominio propio verificado',
    ENTITY_DOMAIN_REMOVED: 'Dominio propio quitado',
    PLATFORM_MAIL_CHANGED: 'Correo de la suite cambiado',
    BACKUP_SETTINGS_CHANGED: 'Ajustes de respaldo cambiados',
    BACKUP_STARTED: 'Respaldo iniciado',
    ENTITY_LOGO_CHANGED: 'Logo cambiado',
    ENTITY_SOURCE_CREATED: 'Fuente registrada',
    ENTITY_SOURCE_UPDATED: 'Fuente modificada',
    ENTITY_SOURCE_DELETED: 'Fuente eliminada',
    ENTITY_SOURCE_ASSIGNED: 'Fuente asignada a una app',
    ENTITY_KEY_CONFIGURED: 'Llave maestra de la entidad configurada',
    ENTITY_KEY_ROTATED: 'Llave de datos de la entidad rotada',
    ENTITY_KEY_TESTED: 'Llave de la entidad probada',
    ENTITY_KEY_UNAVAILABLE: 'Llave de la entidad no disponible',
    MEMBER_APP_ROLES_CHANGED: 'Roles en las apps cambiados',
    APP_ROLES_PUBLISHED: 'Roles de una app publicados',
    APP_MAIL_FEATURES_PUBLISHED: 'Envíos de una app publicados',
    APP_MODULES_PUBLISHED: 'Módulos de una app publicados',
    ENTITY_MAIL_ROUTE_CHANGED: 'Correo de un envío cambiado',
    DATA_LOCATION_CREATED: 'Ubicación de datos creada',
    APP_REGISTERED: 'App registrada',
    APP_UPDATED: 'App modificada',
    APP_SECRET_ROTATED: 'Secreto de una app rotado',
    OIDC_LOGIN: 'Ingreso a una app',
    NOTIFICATIONS_PUSHED: 'Avisos enviados',
    ENTITY_UNIT_CREATED: 'Dependencia creada',
    ENTITY_UNIT_UPDATED: 'Dependencia modificada',
    ENTITY_UNIT_MOVED: 'Dependencia movida',
    ENTITY_UNIT_ARCHIVED: 'Dependencia archivada',
    ENTITY_UNIT_RESTORED: 'Dependencia reactivada',
    ENTITY_UNIT_DELETED: 'Dependencia borrada',
    ENTITY_UNIT_MEMBERS_CHANGED: 'Personas de una dependencia cambiadas',
    ENTITY_UNITS_IMPORTED: 'Organigrama importado de una app',
    ENTITY_UNIT_CHANGE_BLOCKED: 'Cambio del organigrama bloqueado por una app',
};
/** Eventos de la suite misma, que no quedan en ninguna entidad: el filtro de una entidad no los ofrece. */
export const PLATFORM_AUDIT_EVENTS = ['PLATFORM_MAIL_CHANGED', 'BACKUP_SETTINGS_CHANGED', 'BACKUP_STARTED', 'DATA_LOCATION_CREATED', 'APP_REGISTERED', 'APP_UPDATED', 'APP_SECRET_ROTATED', 'PLATFORM_CA_CREATED', 'APP_MAIL_FEATURES_PUBLISHED', 'APP_MODULES_PUBLISHED'];
export const AuditActorKind = { USER: 'USER', INTEGRATION: 'INTEGRATION', SYSTEM: 'SYSTEM', AI: 'AI' };
export const AUDIT_ACTOR_KIND_LABEL = { USER: 'Persona', INTEGRATION: 'App', SYSTEM: 'Sistema', AI: 'IA' };
/** Lista por comas o con la clave repetida (`?event=A&event=B`). */
const csv = (values) => z.union([z.string(), z.array(z.string())]).optional().transform((v) => (v === undefined ? [] : [v].flat().flatMap((x) => x.split(',')).filter(Boolean))).pipe(z.array(z.enum(values)));
/**
 * Filtros de la auditoría (`GET /v1/admin/audit` y `GET /v1/entities/:slug/audit`). `event` y `actorKind` van separados
 * por comas o repetidos; `actor` busca en el correo de quien actuó (o el que se intentó, en un ingreso fallido); `from` incluye y
 * `to` excluye (instantes ISO: la web manda el inicio del día local).
 */
export const auditQuerySchema = z.object({
    event: csv(Object.values(AuditEventType)),
    actorKind: csv(Object.values(AuditActorKind)),
    actor: z.string().trim().max(200).optional(),
    from: z.string().datetime({ offset: true }).optional(),
    to: z.string().datetime({ offset: true }).optional(),
    entity: z.string().optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(100),
});
//# sourceMappingURL=audit.js.map